import { createFetchedDataRecord } from '../../../../utils/fetched-data/create-fetched-data-record';
import { updateObject } from '../../../../utils/object-utils';
import { orderDomainStore } from '../../../order/store';
import { assignOrderRelatedData } from '../../../order/utils/assign-order-related-data';
export const onJourneyLoadSuccess = (response, cacheDuration) => {
    const { journey, relatedData } = response;
    updateObject(orderDomainStore.data.completedOrdersById, createFetchedDataRecord(journey.orders, 'id', cacheDuration));
    assignOrderRelatedData(relatedData, cacheDuration);
    return journey;
};
